/**
 * Service factory helper.
 *
 * Each domain exposes `getXService()` built with this helper. It returns the
 * mock implementation in mock mode and the http implementation in real mode,
 * memoizing the chosen instance. The domain's mode is resolved once at load
 * (see `@/config/runtime` — per-domain override on top of the global default),
 * so the choice is stable for the lifetime of the page.
 */

import { getDomainMode, type ApiDomain } from '@/config/runtime'

export function createServiceFactory<T>(
  domain: ApiDomain,
  makeMock: () => T,
  makeHttp: () => T
): () => T {
  let instance: T | null = null
  return () => {
    if (instance === null) {
      instance = getDomainMode(domain) === 'mock' ? makeMock() : makeHttp()
    }
    return instance
  }
}

/** Simulated network latency for mock services, mirroring the old store delays. */
export function mockDelay(ms = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
